import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6f9d6369")

_pushScopeId("data-v-6f9d6369")
const _hoisted_1 = { class: "bread-crumb-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", { class: "space" }, " >> ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("label", {
      class: "isable",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.change(_ctx.basePath)))
    }, _toDisplayString(_ctx.baseLabel), 1),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.headers, (item) => {
      return (_openBlock(), _createBlock(_Fragment, { key: item }, [
        _hoisted_2,
        _createVNode("label", {
          class: item.path ? 'isable' : '',
          onClick: ($event: any) => (_ctx.change(item.path))
        }, _toDisplayString(item.label), 11, ["onClick"])
      ], 64))
    }), 128))
  ]))
})